<template>
  <div>
    <a-space size="middle" class="search_space">
      <!-- 使用 ranges 内置快捷选项 -->
      <a-range-picker v-model:value="inputs.dateRange" :placeholder="['开始时间', '结束时间']" @change="handleChangeDate" :ranges="{
          '今天': [moment(), moment()],
          '最近7天': [moment().subtract(6, 'days'), moment()],
          '本周': [moment().startOf('week'), moment().endOf('week')],
          '本月': [moment().startOf('month'), moment().endOf('month')],
          '近一年': [moment().subtract(1, 'year'), moment()], // ✅ 已修正：滚动一年
        }" style="width: 360px" />
      <a-select v-model:value="inputs.clubId" show-search placeholder="请选择门店" style="width: 200px" :options="clubOptions" @change="filterLocalData" allowClear />
      <a-select v-model:value="inputs.activityId" show-search placeholder="请选择活动" style="width: 200px" :options="activityOptions" @change="filterLocalData" allowClear />
      <a-button type="primary" shape="circle" @click="search">
        <template #icon>
          <SearchOutlined />
        </template>
      </a-button>
      <a-button @click="resetForm">重置</a-button>
    </a-space>
    <a-table class="ant-table-striped" :columns="columns" :data-source="displayData" :rowClassName="(record, index) => (index % 2 === 1 ? 'table-striped' : null)" bordered rowKey="id" :pagination="{ pageSize: 12 }">
      <template #name="{ record }">
        {{ record.customer?.name || '' }}
      </template>
      <template #mobile="{ record }">
        {{ record.customer?.mobile || '' }}
      </template>
    </a-table>
  </div>
</template>

<script>
import { SearchOutlined } from '@ant-design/icons-vue';
import moment from 'moment';
import { Search } from '/src/api/newCustomerSource';

export default {
  components: { SearchOutlined },
  name: '新客信息管理',
  data() {
    return {
      inputs: {
        clubId: undefined,
        activityId: undefined,
        dateRange: [], // [moment, moment]
      },
      data: [],
      displayData: [],
      columns: [
        { title: '日期', dataIndex: 'createdDate', key: 'createdDate', width: '10%' },
        { title: '姓名', dataIndex: 'name', key: 'name', width: '10%', slots: { customRender: 'name' } },
        { title: '电话', dataIndex: 'mobile', key: 'mobile', width: '15%', slots: { customRender: 'mobile' } },
        { title: '拓客机构', dataIndex: 'clubName', key: 'clubName', width: '15%' },
        { title: '分享人', dataIndex: 'sharerCustomerName', key: 'sharerCustomerName', width: '15%' },
        { title: '拓客活动', dataIndex: 'activityName', key: 'activityName', width: '15%' },
      ],
      clubOptions: [],
      activityOptions: [],
    };
  },
  mounted() {
    this.setDefaultDate();
    this.search();
  },
  methods: {
    moment,
    setDefaultDate() {
      const start = moment().subtract(6, 'days');
      const end = moment();
      this.inputs.dateRange = [start, end];
    },
    handleChangeDate(dates, dateStrings) {
      // 用户手动选择了日期，无需额外操作
      console.log('Date range changed:', dateStrings);
    },
    resetForm() {
      this.inputs.clubId = undefined;
      this.inputs.activityId = undefined;
      this.setDefaultDate();
      this.search();
    },
    async search() {
      // 确保有有效日期范围
      if (!this.inputs.dateRange || this.inputs.dateRange.length !== 2) {
        this.setDefaultDate();
      }
      const [start, end] = this.inputs.dateRange;
      const params = {
        dateFrom: start.format('YYYY-MM-DD'),
        dateTo: end.format('YYYY-MM-DD'),
      };
      try {
        const res = await Search(params);
        if (res.errCode === 0 && Array.isArray(res.data)) {
          this.data = res.data;
          this.displayData = [...this.data];

          // 生成下拉选项
          const clubMap = new Map();
          const activityMap = new Map();
          this.data.forEach((item) => {
            if (item.clubId != null && item.clubName) {
              clubMap.set(item.clubId, item.clubName);
            }
            if (item.activityId != null && item.activityName) {
              activityMap.set(item.activityId, item.activityName);
            }
          });

          this.clubOptions = Array.from(clubMap.entries()).map(([id, name]) => ({
            value: id,
            label: name,
          }));
          this.activityOptions = Array.from(activityMap.entries()).map(([id, name]) => ({
            value: id,
            label: name,
          }));

          // 搜索后清空筛选条件（可选，也可保留）
          this.inputs.clubId = undefined;
          this.inputs.activityId = undefined;
        } else {
          this.$message.error(res.message || '查询失败');
          this.resetData();
        }
      } catch (error) {
        console.error('Search error:', error);
        this.$message.error('请求异常');
        this.resetData();
      }
    },
    resetData() {
      this.data = [];
      this.displayData = [];
      this.clubOptions = [];
      this.activityOptions = [];
    },
    filterLocalData() {
      let result = this.data;
      if (this.inputs.clubId !== undefined && this.inputs.clubId !== null) {
        result = result.filter((item) => item.clubId === this.inputs.clubId);
      }
      if (this.inputs.activityId !== undefined && this.inputs.activityId !== null) {
        result = result.filter((item) => item.activityId === this.inputs.activityId);
      }
      this.displayData = result;
    },
  },
};
</script>

<style scoped>
</style>